const FACEBOOK = 'facebook'
const TWITTER = 'twitter'
const INSTAGRAM = 'instagram'
const REDDIT = 'reddit'
const GOOGLE = 'google'
const BING = 'bing'
const YAHOO = 'yahoo'

export const SOCIAL_PLATFORMS = {
  FACEBOOK,
  TWITTER,
  INSTAGRAM,
  REDDIT,
}

export const SEARCH_PLATFORMS = {
  GOOGLE,
  BING,
  YAHOO,
}

export const PLATFORM_REGEXES = {
  [FACEBOOK]: [/^facebook\./, /\.facebook\./],
  [TWITTER]: [/^twitter\./, /\.twitter\./, /^t\.co/],
  [INSTAGRAM]: [/^instagram\./, /\.instagram\./],
  [REDDIT]: [/^reddit\./, /\.reddit\./],
  [GOOGLE]: [
    /^google\./,
    /\.google\./,
    /googleapi/,
    /googlequicksearchbox/,
    /amp-12up-com/,
    /amp\.12up\.com/,
  ],
  [BING]: [/^bing\./, /\.bing\./],
  [YAHOO]: [/^yahoo\./, /\.yahoo\./],
}

export const UNKNOWN_TRAFFIC_SOURCE = 'unknown'
export const UNKNOWN_TRAFFIC_ID = null

export const INFLUENCER_TRAFFIC_SOURCE = 'influencer'
export const APP_TRAFFIC_SOURCE = 'app'
export const EMBED_PARTNER_TRAFFIC_SOURCE = 'embed_partner'
export const SYNDICATION_TRAFFIC_SOURCE = 'syndication'
export const PAID_TRAFFIC_SOURCE = 'paid'
export const SOCIAL_TRAFFIC_SOURCE = 'social'
export const PARTNER_TRAFFIC_SOURCE = 'tr_partner'
export const ORGANIC_TRAFFIC_SOURCE = 'organic'
export const NAVIGATION_TRAFFIC_SOURCE = 'navigation'
export const RSS_TRAFFIC_SOURCE = 'rss'
export const SHARE_TRAFFIC_SOURCE = 'share'
export const EMAIL_TRAFFIC_SOURCE = 'email'
export const REFERRAL_TRAFFIC_SOURCE = 'referral'
export const DIRECT_TRAFFIC_SOURCE = 'direct'

export const APP_TRAFFIC_ID = null
export const DIRECT_TRAFFIC_ID = null

export const TRAFFIC_INFO_KEY = 'trafficInfo'



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/constants.js